/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // ===== Siteorigen Accordion: autoclose panels ==== 
        $( ".sow-accordion-panel" ).on( "click", function() {
          $( this ).siblings().removeClass("sow-accordion-panel-open").find("> .sow-accordion-panel-content").slideUp();
        });

        // ===== Scroll to Top ==== 
        $(window).scroll(function() {
            if ($(this).scrollTop() > 500) {        // If page is scrolled more than 50px
                $('#go_up').addClass('active');    // Fade in the arrow
            } else {
                $('#go_up').removeClass('active');  // Else fade out the arrow
            }
        });
        $('#go_up').click(function() {      // When arrow is clicked
            $('body,html').animate({
                scrollTop : 0                       // Scroll to top of body
            }, 500);
        });

        // ===== Smooth Scrolling ==== 
        // Select all links with hashes
        $('.plus a[href*="#"]')
          // Remove links that don't actually link to anything
          .not('[href="#"]')
          .not('[href="#0"]')
          .not('[data-togle="tab"]')
          .not('.nav li a')
          .click(function(event) {
            // On-page links
            if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
              && 
              location.hostname == this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                console.log(target.offset().top);
                $('html, body').animate({
                  scrollTop: target.offset().top - 100
                }, 1000 );
              }
            }
          });

        // ===== Activacion animaciones CSS ==== 
        function activacion_animaciones_css(){
          var pos = $(window).scrollTop();
          pos = pos*1;
          pos = pos + (($(window).height() / 4) * 3);
          $('.animation').not('.active').each(function(){
            if (pos > $(this).offset().top) {
              $(this).addClass('active');
            }
          });
        }

        // ===== Header Fixed ==== 
        $(window).bind('scroll', function () {
            if ($(window).scrollTop() > 130) {
                $('header.banner').addClass('fixed');
            } else {
                $('header.banner').removeClass('fixed');
              }
          });


        // ===== Menu Mobile ==== 
        $(document).ready(function() {

          /* menu mobil */
            $('header.banner #nav .ico-mobil').click(function() {
              $('body > #block-system-main-menu').slideToggle();
              $(this).toggleClass('menu-open');
              $('header.banner #nav .ico-mobil .bar').toggleClass('animate');
            });

            $('#block-system-main-menu').clone().insertAfter('header.banner');

          // submenu mobil
            $('#block-system-main-menu ul li.menu-item-has-children').each(function(){
                $('<div class="ico-arrow"></div>').insertBefore($(this).find('.sub-menu'));
            });
            $('#block-system-main-menu ul li .ico-arrow').click(function() {
                $(this).parent().find('ul').slideToggle();
                $(this).parent().toggleClass('open');
            });
        });

        // ===== Form placeholder ==== 
        function placeholder(){
          ancho = $(window).width();
          if (ancho <= 750){
            $('.wpcf7-form .form-item').each(function(){
              var label = $(this).find('label').text();
              $(this).find('input').attr('placeholder', label);
            });
          }else{
            $('.wpcf7-form input, .wpcf7-form textarea').removeAttr('placeholder');
          }
        }

        
        // ===== Brands: more info ==== 
        function measure(father, items, side, cadax){
          $(father).each(function(){
            var a = 0;
            var cont = 0;
            var find = $(this).find(items);
            var j = cadax;
            find.css(side, '');
            find.each(function(i){

              if (parseInt($(this).css(side).split('p')[0]) > a){
                a = parseInt($(this).css(side).split('p')[0]);
              }

              if (cadax !== false){
                if (cont == (cadax-1)){
                  for (var c = cadax - 1; c >= 0; c--) {
                    find.eq(i - c).css(side, a+'px');
                  }
                  a=0;
                  cont=0;
                }else{
                  cont++;
                }
              }
            });
            if (cadax !== false && cont > 0){
              for (var c = 0; c <= cont; c++) {
                find.eq(find.length - c).css(side, a+'px');
              }
            }
            if (cadax == false) find.css(side, a+'px');

          });
        }

        function more_info_brands(){

          function trim_text(elem){
            var text = elem.find('.text').html();
            var text_trimmed = substring(text, 200) + '...';
            var r = text_trimmed.length;
            text_trimmed += ' <span class="org">'+text+'</span>';
            elem.find('.text').html(text_trimmed);
            return r;
          }

          function substring(string, max_char){
            var pos = 0;
            for (var i = max_char - 10; i < max_char + 10; i++) {
              if (string[i] == ' '){
                pos = i;
                break;
              }
            }
            return string.substring(0, pos);
          }

          $('.paragraphs-item-brands .noexpand').each(function(){
            var text = $(this).html();
            var text_trimmed = substring(text, 200) + '...';
            $(this).html('<div class="text">'+text_trimmed+'</div>');
            measure('.paragraphs-item-brands', '.text', 'height', false);
          });

          $('.paragraphs-item-brands .info').each(function(){
            var org = $(this).text();
            $(this).html('<div class="text">'+$(this).html()+'</div><span class="plus more"><a href="#"></a></span><br/>');
            if (org.length == trim_text($(this))){
              $(this).find('.more').remove();
              $(this).parent().find('.path').addClass('no_more');
            }
            measure('.paragraphs-item-brands', '.text', 'height', false);
          });

          $('.paragraphs-item-brands').on( "click", '.info .less', function(e) {
            e.preventDefault();
            var parent = $(this).parent();
            trim_text(parent);
            parent.removeClass('active');
            $(this).removeClass('less').addClass('more');
            //measure('.paragraphs-item-brands', '.views-row', 'height', false);
            measure('.paragraphs-item-brands', '.info:not(.active) .text', 'height', false);
          });

          $('.paragraphs-item-brands').on( "click", '.info .more', function(e) {
            e.preventDefault();
            var parent = $(this).parent();
            parent.addClass('active');
            var text = parent.find('.org').html();
            parent.find('.text').css('height','auto').html(text);
            $(this).removeClass('more').addClass('less');
            //measure('.paragraphs-item-brands', '.views-row', 'height', false);
          });

        }



        // ===== Responsive Tables ==== 
        $(document).ready(function() {
          var switched = false;
          var updateTables = function() {
            if (($(window).width() < 991) && !switched ){
              switched = true;
              $("table.territory").each(function(i, element) {
                $(this).find('thead th:first-child').removeClass('hidden').next().attr("colspan", "1");
              });              
              $("table.responsive").each(function(i, element) {
                splitTable($(element));
              });
              return true;
            }
            else if (switched && ($(window).width() > 991)) {
              switched = false;
              $("table.territory").each(function(i, element) {
                $(this).find('thead th:first-child').addClass('hidden').next().attr("colspan", "2");
              }); 
              $("table.responsive").each(function(i, element) {
                unsplitTable($(element));
              });
            }
          };
           
          $(window).load(updateTables);
          $(window).on("redraw",function(){switched=false;updateTables();}); // An event to listen for
          $(window).on("resize", updateTables);
           
          
          function splitTable(original)
          {
            original.wrap("<div class='table-wrapper' />");
            
            var copy = original.clone();
            copy.find("td:not(:first-child), th:not(:first-child)").css("display", "none");
            copy.removeClass("responsive");
            
            original.closest(".table-wrapper").append(copy);
            copy.wrap("<div class='pinned' />");
            original.wrap("<div class='scrollable' />");

            setCellHeights(original, copy);
          }
          
          function unsplitTable(original) {
            original.closest(".table-wrapper").find(".pinned").remove();
            original.unwrap();
            original.unwrap();
          }

          function setCellHeights(original, copy) {
            var tr = original.find('tr'),
                tr_copy = copy.find('tr'),
                heights = [];

            tr.each(function (index) {
              var self = $(this),
                  tx = self.find('th, td');

              tx.each(function () {
                var height = $(this).outerHeight(true);
                heights[index] = heights[index] || 0;
                if (height > heights[index]) heights[index] = height;
              });

            });

            tr_copy.each(function (index) {
              $(this).height(heights[index]);
            });
          }

        });

        // ===== Video Background ==== 
        function video_slider(){
          $('.view-mode-visualization_2').each(function(){
            var elem = $(this).find('video');
            var contenedor = $(this).closest('.paragraphs-item-slider-header');
            if ($(window).width() > 750){
              elem.closest('.field').fadeIn();
              contenedor.find('.field-name-field-pr-si-background').fadeOut();

              var h_contenedor = contenedor.outerHeight();
              var w_contenedor = contenedor.outerWidth();
              var plus_w = 40;


              elem.css({"height":"", "width":"", "margin":""});

              var w_video = $(window).width() + plus_w;
              var h_video = w_video / 1.8;
              var margin_top = (h_video - h_contenedor) * -1;
              var margin_left = (w_video / 4) * -1;

              elem.css('height',h_video+'px');
              elem.css('width',w_video+'px');
              elem.css('margin-left',-(plus_w / 2)+'px');
              elem.css('margin-top',margin_top+'px');

            }else{
              elem.closest('.field').fadeOut();
              contenedor.find('.field-name-field-pr-si-background').fadeIn();
            }
          });
        }

        // ===== Responsive Table: Data Segmentation ===== 
        function resize_cells(){
          $('.scroll-table td').each(function(){

              if ($(window).width() < 750){
                var w_width = $(window).width() - 30;
                $(this).css('min-width',w_width+'px');

              }

          });
        }

        // ===== Modal image auto width ==== 
        function centerModal() {

            var dialog = $(this).find(".modal-dialog");
            var img = $(this).find("img.aligncenter");
            var offset = img.width();

            dialog.css("width", offset);
        }

        $('.modal').on('show.bs.modal', centerModal);



        // ===== Ejecutar funciones ==== 
        $(document).ready(function(){
          placeholder();
          more_info_brands();
          video_slider();
          activacion_animaciones_css();
          resize_cells();

          $(window).resize(function(){
            placeholder();
            video_slider();
            resize_cells();
            //measure('.paragraphs-item-brands', '.info:not(.active) .text', 'height', false);
            measure('.paragraphs-item-brands', '.text', 'height', false);
          });

          $(window).bind('scroll', function () {
            activacion_animaciones_css();
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
